// import { t } from "i18next";

// export const availableCredits = [
//   { value: 1, label: t("one_to_one.credits_1", { defaultValue: "1 to 4 credits" }), price: "€25" },
//   { value: 3, label: t("one_to_one.credits_2", { defaultValue: "5 to 10 credits" }), price: "€23.6" },
//   { value: 5, label: t("one_to_one.credits_3", { defaultValue: "11 to 23 credits" }), price: "€22.2" },
//   { value: 10, label: t("one_to_one.credits_4", { defaultValue: "24 to 34 credits" }), price: "€20.7" },
//   { value: 24, label: t("one_to_one.credits_5", { defaultValue: "35+ credits" }), price: "€19.5" },
// ];

export const availableCredits = [
  { value: 1, label: "one_to_one.credits_1", price: "€25" },
  { value: 3, label: "one_to_one.credits_2", price: "€23.6" },
  { value: 5, label: "one_to_one.credits_3", price: "€22.2" },
  { value: 10, label: "one_to_one.credits_4", price: "€20.7" },
  { value: 24, label: "one_to_one.credits_5", price: "€19.5" },
];
